import { create } from "zustand";
import { RoadFeatures, RoadFeaturesWithBruksklasse, RouteResponseOfRoadFeatures, RouteResponseOfRoadFeaturesWithBruksklasse } from "../services/RuteplanAPI";

export type RouteResponse = RouteResponseOfRoadFeatures | RouteResponseOfRoadFeaturesWithBruksklasse;
export type RoadFeatureResponse = RoadFeatures | RoadFeaturesWithBruksklasse;

export interface IRouteActions {
    setRouteResponse: (routeResponse: RouteResponse | null) => void;
    setSelectedRouteIndex: (index: number) => void;
    setIsLoading: (isLoading: boolean) => void;
    setRouteDrawerOpen: (isOpen: boolean) => void;
    setRoadFeatureResponse: (roadFeatureResponse: RoadFeatureResponse | undefined) => void;
    setControlsOpen: (controlsOpen: boolean) => void;
}

export interface IRouteState {
    routeResponse: RouteResponse | null;
    selectedRouteIndex: number;
    actions: IRouteActions;
    isLoading: boolean;
    routeDrawerOpen: boolean;
    roadFeatureResponse: RoadFeatureResponse | undefined;
    controlsOpen: boolean;
}

const useRouteStore = create<IRouteState>((set) => ({
    routeResponse: null,
    selectedRouteIndex: 0,
    isLoading: false,
    routeDrawerOpen: false,
    roadFeatureResponse: undefined,
    controlsOpen: false,
    actions: {
        setRouteResponse: (routeResponse: RouteResponse | null) => {
            set({
                routeResponse: routeResponse
            })
        },
        setSelectedRouteIndex: (index: number) => {
            set({
                selectedRouteIndex: index
            })
        },
        setIsLoading: (isLoading: boolean) => {
            set({
                isLoading: isLoading
            })
        }, setRouteDrawerOpen: (isOpen: boolean) => {
            set({
                routeDrawerOpen: isOpen
            })
        },
        setRoadFeatureResponse: (roadFeatureResponse: RoadFeatures | RoadFeaturesWithBruksklasse | undefined) => {
            set({
                roadFeatureResponse: roadFeatureResponse
            })
        },
        setControlsOpen: (controlsOpen: boolean) => {
            set({
                controlsOpen: controlsOpen
            })
        }
    }
}));

export const useRouteResponse = () => useRouteStore((state) => state.routeResponse);
export const useSelectedRouteIndex = () => useRouteStore((state) => state.selectedRouteIndex);
export const useIsLoading = () => useRouteStore((state) => state.isLoading);
export const useRouteStoreActions = () => useRouteStore((state) => state.actions);
export const useRouteDrawerOpen = () => useRouteStore((state) => state.routeDrawerOpen);
export const useRoadFeatureResponse = () => useRouteStore((state) => state.roadFeatureResponse);
export const useControlsOpen = () => useRouteStore((state) => state.controlsOpen);
